import React from 'react';
import { useParams } from 'react-router';

import { ContractView } from './ContractView';

type ParamTypes = {
  contractId?: string;
};

export const ContractNoTVView: React.FC = () => {
  const { contractId } = useParams<ParamTypes>() as {
    contractId?: string;
  };

  return <ContractView contractId={contractId} tv={false} />;
};
